// extracted by mini-css-extract-plugin
export default {"loaderWrap":"AddSupportStaffModal_loaderWrap__CD+Dx"};